import { useState, useCallback } from 'react';
import { useHttp } from './useHttp';
import { useAuth } from './useAuth';
import { normalizeRaffle } from 'src/utils/raffleHelpers';
import type { Raffle } from 'src/types/raffle';

interface UseRaffleDetailReturn {
  raffle: Raffle | null;
  isLoading: boolean;
  error: string | null;
  fetchRaffle: (id: string) => void;
}

export function useRaffleDetail(): UseRaffleDetailReturn {
  const { isLoading, error, sendRequest } = useHttp();
  const { accessToken } = useAuth();
  const [raffle, setRaffle] = useState<Raffle | null>(null);

  const fetchRaffle = useCallback(
    (id: string) => {
      sendRequest(
        { url: `raffles/${id}`, accessToken: accessToken || undefined },
        (response: unknown) => {
          setRaffle(normalizeRaffle(response));
        },
      );
    },
    [sendRequest, accessToken],
  );

  return { raffle, isLoading, error, fetchRaffle };
}
